// removed by extract-text-webpack-plugin
module.exports = {"noKnowledgebases":"noKnowledgebases__1Yl-6RHSvOvP"};